import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from "../../share/service/alert.service";
import { AuthenticateGrabIDClientService } from '../../share/service/authenticateGrabIDClient.service';

@Component({
  selector: 'app-grab-oauth-callback',
  templateUrl: './grab-oauth-callback.component.html',
  styleUrls: ['./grab-oauth-callback.component.css']
})
export class GrabOAuthCallbackComponent implements OnInit {

  constructor(
    private alertService: AlertService,
    private authenticateGrabIDClientService: AuthenticateGrabIDClientService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    try {
      const { code } = this.authenticateGrabIDClientService.handleAuthenticateOAuthCallback();
      window.location.href = `/affiliates?partnerCode=grabc&code=${code}`;
    } catch (error) {
      this.alertService.openSnackBar("Grab OAuth callback handling failed");
    }
  }
}
